import React from 'react';

export interface EditAlignmentCommentProps {
  end: string | null;
  start: string | null;
  text: string | null;
}

export function EditAlignmentCommentInput({end, start, text}: EditAlignmentCommentProps): JSX.Element {
  return (
    <>
      <div className="close-wrapper">
        <span className="badge-close pull-right close">&times;</span>
      </div>
      <textarea
        placeholder="Comment"
        className="message"
        // eslint-disable-next-line benchlint/no-eqeqeq-null
        defaultValue={text === null ? undefined : text}
      />
      <div className="info-wrapper">
        <div className="info">
          <div className="u-lr-split">
            <div className="u-vertical-center-items">
              <input
                type="number"
                placeholder="Start"
                min="1"
                step="1"
                className="start"
                // eslint-disable-next-line benchlint/no-eqeqeq-null
                defaultValue={start === null ? undefined : start}
              />
              <span className="dash">&ndash;</span>
              <input
                type="number"
                placeholder="End"
                min="1"
                step="1"
                className="end"
                // eslint-disable-next-line benchlint/no-eqeqeq-null
                defaultValue={end === null ? undefined : end}
              />
              <div className="buttonGroup">
                <button type="button" className="button button--small button--primary save">
                  Save
                </button>
              </div>
            </div>
            <div>
              <span className="glyphicon glyphicon-trash pull-right delete" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
